import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "submitButton", "saveButton"]

  submitForm() {
    // Trigger form submission by clicking hidden submit button
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click()
    } else if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }

  async submit(event) {
    event.preventDefault()

    const form = this.formTarget
    const formData = new FormData(form)
    const url = form.action
    const method = form.method
    const saveBtn = this.hasSaveButtonTarget ? this.saveButtonTarget : null
    const originalText = saveBtn ? saveBtn.textContent.trim() : null
    const minDelay = 600
    const startTime = Date.now()
    let success = false

    if (saveBtn) {
      saveBtn.disabled = true
    }

    try {
      const response = await fetch(url, {
        method: method,
        body: formData,
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
          "Accept": "application/json"
        }
      })

      if (response.ok) {
        const data = await response.json()
        success = true

        // Don't close the modal - keep it open for further edits
        // Show success feedback (optional - could add a toast notification here)
        console.log("Brain chat settings updated successfully", data)
      } else {
        const error = await response.json()
        console.error("Failed to update settings:", error)
        alert("Failed to update mind chat settings. Please try again.")
      }
    } catch (error) {
      console.error("Error updating settings:", error)
      alert("An error occurred. Please try again.")
    } finally {
      const elapsed = Date.now() - startTime
      const remaining = Math.max(0, minDelay - elapsed)

      if (remaining > 0) {
        await new Promise(resolve => setTimeout(resolve, remaining))
      }

      if (saveBtn) {
        if (success) {
          saveBtn.textContent = "Saved"
          setTimeout(() => {
            saveBtn.disabled = false
            saveBtn.textContent = originalText
          }, 1200)
        } else {
          saveBtn.disabled = false
          saveBtn.textContent = originalText
        }
      }
    }
  }
}
